import React from 'react'

import mystic from '../../images/MYSTIC.png'
import mystic3 from '../../images/MYSTIC.3.jpg'
import mystic5 from '../../images/MYSTIC 5..jpg'

function Mystic() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={mystic}
            className="project-image" />
          <img
            src={mystic3}
            className="project-image" />
          <img
            src={mystic5}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Mystic</h1>
          <p className="Project-text">
            <strong>Television Series
              <br />
CBBC + TVNZ
              <br />

Directors: Peter Salmon, Aidee Walker
              <br />
              2019-2020
              <br />
              <br />
            - nominated Best Children’s Show in the NZ Television Awards 2021
              <br />
              <br />

Rehearsal + On Set Acting Coach
Coached the 6 core cast (ages 11, 16, 17, 17, 19, 20)

            </strong>
          </p>
          <p className="Project-testimonial">
            "Ella's coaching skills were invaluable for me directing 'Mystic'. Her down-to-earth, intuitive approach with the young cast created a trusting environment resulting in fantastic memorable performances
”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Peter Salmon, director</strong>
          </h6>
          <p className="Project-testimonial">
            "Ella managed to bring out the personality I have around my friends. She has this amazing way of connecting with people that make them feel calm and confident in themselves. She has helped me push away my self-consciousness so that I am able to fully immerse myself into my character without fear of judgement.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Jacqueline Jo,  actor - Caroline</strong>
          </h6>
          <p className="Project-testimonial">
            "Ella helped me a lot on the set of mystic. Going to New Zealand was scary because I didn’t know anyone. However she made me feel so welcomed and supported. She helped all cast on set and in rehearsal, allowing us as actors to bond and build a really strong relationship. She was there for me on my good and bad days, she helped me improve as an actor and to develop my character. She’s so talented and lovely. I couldn't have asked for a better friend and acting coach.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Macey Chipping, lead actor, Issie
</strong>
          </h6>
        </div>
      </div>
    </div>
  )
}

export default Mystic
